import { render, staticRenderFns } from "./NavigateableQuestionTab.vue?vue&type=template&id=eac21168&"
import script from "./NavigateableQuestionTab.vue?vue&type=script&lang=js&"
export * from "./NavigateableQuestionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eac21168')) {
      api.createRecord('eac21168', component.options)
    } else {
      api.reload('eac21168', component.options)
    }
    module.hot.accept("./NavigateableQuestionTab.vue?vue&type=template&id=eac21168&", function () {
      api.rerender('eac21168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/QuestionTab/NavigateableQuestionTab.vue"
export default component.exports